import React, { useEffect, useMemo, useState } from "react";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import { useFetchRedemptionHistoryMutation } from "../../../features/tenant/redeemptionHistory/redemptionHistoryApi";
import { hasPermission } from "../../../utils/hasPermission";
import { useNavigate } from "react-router-dom";
import { getVendorName } from "../../../utils/getVendorName";
import ModalComponent from "../../../components/Tenant/ModalComponent/ModalComponent";
import {
  useGetExtraRedeemedGiftsStatusMutation,
  useGetRedeemedGiftsStatusQuery,
  useUpdateDeliveryDetailsGiftRedemptionMutation,
  useUpdateIsAddressVerifiedMutation,
  useUpdateRedeemedGiftsStatusMutation,
} from "../../../features/tenant/redeemedGiftsStatus/redeemedGiftsStatusApi";
import SelectComponent from "../../../components/Tenant/SelectComponent/SelectComponent";
import { toast } from "react-hot-toast";
import { getLoginUserData } from "../../../utils/getLoginUserData";
import { useGetAllZoneMutation } from "../../../features/tenant/zones/zonesApi";
import CustomExport from "../../../components/CustomExport/CustomExport";
import { TiTimes } from "react-icons/ti";
import { transformToJSON } from "../../../redeemRequestJsonToCsv";
import { useGetUserPointsByAppUserIdMutation } from "../../../features/tenant/userPoints/userPointsApi";
import { formatter } from "../../../utils/numberFormatter";
import TenantSlugs from "../../../utils/TenantSlug";
import { useUploadMultipleFilesMutation } from "../../../features/admin/imageUpload/imageUploadApi";
import {
  useGetApprovalLogsByRefMutation,
  useGetBatchApprovalStatusMutation,
  useGiftWorkflowActionMutation,
} from "../../../features/tenant/approvalLog/approvalLog.Api";


const getRedemptionType = (type) => {

  const redemptionTypes = ["", "Gift", "Cash", "", "Dream Gift"]


  return redemptionTypes[type];
}

const RedeemRequest = () => {

  const redemptionHierarchyzoneId = getLoginUserData().zone_id;
  const vendorData = JSON.parse(sessionStorage.getItem("companyProfile"));
  const redemptionHierarchy = vendorData.redemption_hierarchy && vendorData.redemption_hierarchy.gift_mapped_users;
  // console.log("redemptionHierarchy", redemptionHierarchy);

  const [myList, setMyList] = useState([]);
  const [totalRows, setTotalRows] = useState(0);

  const [showAddressModal, setshowAddressModal] = useState(false);

  const [addressStatus, setAddressStatus] = useState(null);

  const [popUpBtnToggle, setPopUpBtnToggle] = useState(false);
  const [giftDetailPopUpToggle, setGiftDetailPopUpToggle] = useState(false);
  const [giftDetails, setGiftDetails] = useState(null);
  const [selectStatus, setSelectStatus] = useState(1);
  const [currentRefNo, setCurrentRefNo] = useState("");
  const [progressBtnToggle, setProgressBtnToggle] = useState(false);
  const [currentStatus, setCurrentStatus] = useState(0);
  const [row, setRow] = useState([]);
  const appUserTypes = JSON.parse(sessionStorage.getItem("appUserType")) || [];
  const [appUsers, setAppUsers] = useState(appUserTypes);
  const [userZone, setUserZone] = useState({
    name: "All Zones",
    id: 0,
  });
  const [allZones, setAllZones] = useState([]);
  const [userTypesArray, setUserTypesArray] = useState({
    name: "All",
    id: null,
  });
  const [userTypeId, setUserTypeId] = useState(userTypesArray.id);
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [paginationResetToggle, setPaginationResetToggle] = useState(false);
  const [currentUserType, setCurrentUserType] = useState(null);
  const [lastStatus, setLastStatus] = useState(null);
  const [extraStatus, setExtraStatus] = useState([]);
  const [podFiles, setPODFiles] = useState([])

  const [deliveryDetailsModalToggle, setDeliveryDetailsModalToggle] = useState(false);
  const [deliveryDetailsSelectedData, setDeliveryDetailsSelectedData] = useState(null);
  const [updatedDeliveryPartner, setUpdatedDeliveryPartner] = useState("");
  const [updatedTrackingId, setUpdatedTrackingId] = useState("");

  const [
    getAllZone,
    {
      data: getAllZoneData,
      isLoading: getAllZoneIsLoading,
      isError: getAllZoneIsError,
      error: getAllZoneError,
    },
  ] = useGetAllZoneMutation();
  const currentDate = new Date().toISOString().split("T")[0];
  const initialRequest = {
    name: "",
    mobile: "",
    user_type_id: userTypeId,
    limit: 10,
    offset: 0,
    startDate: "",
    endDate: "",
  };
  const [request, setRequest] = useState(initialRequest);
  const clearFilters = () => {
    setRequest(initialRequest);
    setUserZone({
      name: "All Zones",
      id: 0,
    });
    setUserTypesArray({
      name: "All",
      id: null,
    })
  };

  useEffect(() => {
    getAllZone({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
    });
  }, []);

  useEffect(() => {
    if (getAllZoneData) {
      const allZone = getAllZoneData.body.map((x) => {
        return {
          id: x.id,
          name: x.zone_name,
        };
      });

      setAllZones(allZone);
    }
    if (getAllZoneError) {
      toast.dismiss();
      toast.error(getAllZoneError.data.message, {
        id: "errorAtGetallzonedata",
      });
    }
  }, [getAllZoneData, getAllZoneError]);

  const [
    fetchRedemptionHistory,
    { data: redemptionHistoryData, error: redemptionHistoryError },
  ] = useFetchRedemptionHistoryMutation();

  const [
    fetchRedemptionHistoryCsv,
    { data: redemptionHistoryCsvData, error: redemptionHistoryCsvError },
  ] = useFetchRedemptionHistoryMutation();
  const [
    updateRedeemedGiftsStatus,
    {
      data: updateRedeemedGiftsStatusData,
      error: updateRedeemedGiftsStatusError,
    },
  ] = useUpdateRedeemedGiftsStatusMutation();

  const [
    updateDeliveryDetails,
    {
      data: updateDeliveryDetailsData,
      error: updateDeliveryDetailsError,
      isLoading: updateDeliveryDetailsIsLoading
    },
  ] = useUpdateDeliveryDetailsGiftRedemptionMutation();

  const [balancePopupModal, setBalancePopupModal] = useState(false);
  const [balanceDetails, setBalanceDetails] = useState(null);
  const [
    getUserPointsData,
    {
      data: userPointsData,
      isLoading: userPointsisLoading,
      error: userPointsError,
    },
  ] = useGetUserPointsByAppUserIdMutation();

  const {
    data: getRedeemedGiftsStatusData,
    error: getRedeemedGiftsStatusError,
  } = useGetRedeemedGiftsStatusQuery({
    token: sessionStorage.getItem("access_token"),
    tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
  });

  const [
    getExtraRedeemedGiftsStatus,
    {
      data: getExtraRedeemedGiftsStatusData,
      error: getExtraRedeemedGiftsStatusError,
    },
  ] = useGetExtraRedeemedGiftsStatusMutation();

  useEffect(() => {
    if (currentUserType != null) {
      getExtraRedeemedGiftsStatus({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        user_type: currentUserType,
      });
    }
  }, [currentUserType]);

  useEffect(() => {
    if (getExtraRedeemedGiftsStatusData) {
      setExtraStatus(getExtraRedeemedGiftsStatusData.body)
    }
  }, [getExtraRedeemedGiftsStatusData]);


  const navigate = useNavigate();

  const handleFetchRedemptionHistory = () => {
    fetchRedemptionHistory({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: request,
      zoneId: userZone.id,
    });
  };

  const handleFetchRedemptionHistoryCsv = () => {
    const modifiedRequest = {
      ...request,
      limit: null,
      offset: null,
    };
    fetchRedemptionHistoryCsv({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: modifiedRequest,
      zoneId: userZone.id,
    });
  };


  const fetchUserPointsData = (appUserId) => {
    if (!appUserId) {
      toast.error("Invalid ID");
      return;
    } else {
      getUserPointsData({
        token: sessionStorage.getItem("access_token"),
        tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
        app_user_id: appUserId,
      });
    }
  }


  useEffect(() => {
    toast.dismiss();

    if (userPointsData && userPointsData.body) {
      console.log("userPointsData", userPointsData);
      toast.dismiss();
      setBalancePopupModal(true);
      setBalanceDetails({
        point_earned: userPointsData.body.point_earned,
        point_balance: userPointsData.body.point_balance,
        point_redeemed: userPointsData.body.point_redeemed,
      });
    }

    if (userPointsError) {
      toast.error("Something went wrong", { id: "userPointsError" });
    }


    if (userPointsisLoading) {
      toast.loading("Fetching point data", { id: "userPointsisLoading" });
    }
  }, [userPointsData, userPointsError, userPointsisLoading])


  const [csvData, setCsvData] = useState(null);
  useEffect(() => {
    if (redemptionHistoryCsvData && redemptionHistoryCsvData?.body?.data) {
      console.log("csvData", redemptionHistoryCsvData?.body?.data);
      if (JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == 25 || JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == 30 || JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == 21) {
        setCsvData(transformToJSON(redemptionHistoryCsvData?.body?.data, csvColumns));
      } else {
        setCsvData(redemptionHistoryCsvData?.body?.data);
      }
    }

    if (redemptionHistoryCsvError) {
      setCsvData(null);
    }
  }, [redemptionHistoryCsvData, redemptionHistoryCsvError]);

  useEffect(() => {
    const hasViewPermission = hasPermission("redeemRequestList");
    console.log(hasViewPermission);

    if (!hasViewPermission) {
      navigate(`/genefied/${getVendorName()}/`);
    }
    // if(limit!=10||offset!=0)
    handleFetchRedemptionHistory();
    // handleFetchRedemptionHistoryCsv();
  }, [request, limit, offset]);

  useEffect(() => {
    if (redemptionHistoryData) {
      const rows = redemptionHistoryData.body?.data ?? [];
      setMyList(rows);
      setTotalRows(redemptionHistoryData.body?.total ?? 0);
      // Enrich with per-row workflow state
      if (rows.length) fetchWorkflowStatus(rows);
    }
    if (redemptionHistoryError) console.log("redemtion error", redemptionHistoryError);
  }, [redemptionHistoryData, redemptionHistoryError]);

  const handleUpdateRedeemedGiftsStatus = () => {
    console.log("selectStatus", selectStatus);
    console.log("lastStatus", lastStatus);

    if (lastStatus == 0) {
      toast.error("This request has already been rejected. You cannot change the status.", { id: "rejected-status" });
      return;
    }

    if (selectStatus == lastStatus) {
      toast.error("you can not update same");
      return;
    }

    if (lastStatus == 1 && selectStatus > 2) {
      toast.error("You need to change the status to approved first.", { id: "approved-status-required" });
      return;
    }

    if (lastStatus == 2 && selectStatus < 2) {
      toast.error("Status can't be updated", { id: "status-not-updated" });
      return;
    }

    // if( Number(selectStatus) > 10){

    // }else{
    //   if( selectStatus != lastStatus+1){
    //     toast.error("you can't select this status directly");
    //     return;
    //   }

    // }

    // return;
    updateRedeemedGiftsStatus({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        status: selectStatus,
        ref_no: currentRefNo,
        status_change_at: "2",
      },
    });
  };
  useEffect(() => {
    if (updateRedeemedGiftsStatusData) {
      toast.dismiss();
      toast.success(`${updateRedeemedGiftsStatusData.message}`, {
        id: `updateRedeemedGiftsStatusData`,
      });
      handleFetchRedemptionHistory(limit, offset);
      setPopUpBtnToggle(false);
    }

    if (updateRedeemedGiftsStatusError) {
      toast.dismiss();
      toast.error(`${updateRedeemedGiftsStatusError.data.message}`, {
        id: `updateRedeemedGiftsStatusError`,
      });
      setPopUpBtnToggle(false);
    }
  }, [updateRedeemedGiftsStatusData, updateRedeemedGiftsStatusError]);

  useMemo(() => {
    for (let index = 0; index < appUsers.length; index++) {
      const element = appUsers[index];
      if (
        element.user_type.toLocaleLowerCase() ===
        userTypesArray?.name?.toLocaleLowerCase()
      ) {
        setUserTypeId(element.user_type_id);
        setRequest((prevRequest) => ({
          ...prevRequest,
          user_type_id: +element.user_type_id,
        }));
        break;
      }
    }
  }, [userTypesArray]);

  const handleReject = () => {};

  // ── Approval workflow (gift_redemption) ──────────────────────────────────
  const tenant_id_num = JSON.parse(sessionStorage.getItem("vendorData")).tenant_id;

  // Per-row workflow state: { [id]: { can_approve, is_fully_approved, is_rejected, current_level, ... } }
  const [rowWorkflowStatus, setRowWorkflowStatus] = useState({});

  const [getBatchApprovalStatus] = useGetBatchApprovalStatusMutation();

  const fetchWorkflowStatus = (rows) => {
    const ids = rows.map((r) => r.id).filter(Boolean);
    if (!ids.length) return;
    getBatchApprovalStatus({
      token: sessionStorage.getItem("access_token"),
      tenant_id: tenant_id_num,
      ref_table_name: "user_point_redemptions",
      ref_ids: ids,
    }).then((resp) => {
      if (resp?.data?.body) {
        setRowWorkflowStatus((prev) => ({ ...prev, ...resp.data.body }));
      }
    });
  };

  // Workflow action modal
  const [wfModal, setWfModal]       = useState(false);
  const [wfRow, setWfRow]           = useState(null);
  const [wfAction, setWfAction]     = useState("approve"); // "approve" | "reject"
  const [wfRemark, setWfRemark]     = useState("");

  const [giftWorkflowActionFn, { data: wfActionData, error: wfActionError, isLoading: wfLoading }] = useGiftWorkflowActionMutation();

  const openWfModal = (row, action) => {
    setWfRow(row);
    setWfAction(action);
    setWfRemark("");
    setWfModal(true);
  };

  const handleWfConfirm = () => {
    if (!wfRemark.trim()) { toast.error("Remark is required"); return; }
    giftWorkflowActionFn({
      token: sessionStorage.getItem("access_token"),
      tenant_id: tenant_id_num,
      ref_no: wfRow.ref_no,
      action: wfAction,
      remark: wfRemark.trim(),
    });
    setWfModal(false);
  };

  // Approval history per-row modal
  const [historyModal, setHistoryModal] = useState(false);
  const [historyRow, setHistoryRow]     = useState(null);
  const [historyLogs, setHistoryLogs]   = useState([]);
  const [getApprovalLogsByRef, { isLoading: historyLoading }] = useGetApprovalLogsByRefMutation();

  const openHistory = (row) => {
    setHistoryRow(row);
    setHistoryLogs([]);
    setHistoryModal(true);
    getApprovalLogsByRef({
      token: sessionStorage.getItem("access_token"),
      tenant_id: tenant_id_num,
      ref_table_name: "user_point_redemptions",
      ref_table_id: row.id,
    }).then((resp) => {
      if (resp?.data?.body) setHistoryLogs(resp.data.body);
    });
  };
  // ─────────────────────────────────────────────────────────────────────────

  const [uploadMultipleFiles, {isLoading: filesUploading, data: filesData}] =  useUploadMultipleFilesMutation();


  const handleUpdateDeliveryDetails = async () => {
      let filesToUpload = podFiles.filter((file) => file instanceof File);

      let documents = podFiles.filter((file) => !(file instanceof File));

      if (filesToUpload?.length) {
          let formData = new FormData();

          filesToUpload.forEach((file) => {
              formData.append("images", file); // one append per file
          });

          const response = await uploadMultipleFiles({
              token: sessionStorage.getItem("access_token"),
              body: formData,
          }).unwrap();

          if (response?.body?.length) {
              documents = [...documents, ...response?.body];
          }
      }

      const requestBody = {
          ref_no: deliveryDetailsSelectedData.ref_no,
          tracking_id: updatedTrackingId,
          delivery_partner: updatedDeliveryPartner,
          image: documents,
      };

      updateDeliveryDetails({
          token: sessionStorage.getItem("access_token"),
          tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
          body: requestBody,
      });
  };

  useEffect(() => {
    if (updateDeliveryDetailsData && updateDeliveryDetailsData?.body) {
      toast.dismiss();
      toast.success("Delivery Details Updated.", { id: "updateDeliveryDetailsData" })
      handleFetchRedemptionHistory(limit, offset);
      setPODFiles([])
      setDeliveryDetailsModalToggle(false);
      setDeliveryDetailsSelectedData(null);
    }

    if (updateDeliveryDetailsError) {
      toast.dismiss();
      toast.error("Something went wrong", { id: "updateDeliveryDetailsError" })
      console.error("updateDeliveryDetailsError", updateDeliveryDetailsError);
    }

    if (updateDeliveryDetailsIsLoading) {
      toast.loading("Please wait..", { id: "updateDeliveryDetailsIsLoading" })
    }
  }, [updateDeliveryDetailsData, updateDeliveryDetailsError, updateDeliveryDetailsIsLoading])

  const columns = [
    {
      name: "SNo",
      cell: (row, idx) => offset + Number(idx + 1),
      sortable: true,
      width: "80px",
    },
    {
      name: "Platform",
      cell: (row) => row.platform,
      sortable: true,
      width: "120px",
    },
    {
      name: "Name",
      cell: (row) => row.name,
      sortable: true,
      width: "120px",
    },
    {
      name: "Email",
      cell: (row) => row.email,
      sortable: true,
      width: "120px",
    },
    {
      name: "Mobile",
      cell: (row) => row.mobile,
      sortable: true,
      width: "120px",
    },
    {
      name: "User Type",
      cell: (row) => row.user_type,
      sortable: true,
      width: "120px",
    },
    ...TenantSlugs.sudama == JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ? [
      {
        name: "Updated Name",
        selector: (row) => row.updated_by_name,
      },
      {
        name: "Updated Mobile",
        selector: (row) => row.updated_by_mobile,
      },
      {
        name: "Updated Email",
        selector: (row) => row.updated_by_email,
      },
      {
        name: "Order Points",
        selector: (row) => row.points - (row.gift_balance || 0),
      },
      {
        name: "Bonus Points",
        selector: (row) => row.gift_balance || 0,
      },

    ] : [],
    ...JSON.parse(sessionStorage.getItem("vendorData")).tenant_id == TenantSlugs.siyaram ?
      [
        {
          name: "Firm Name",
          cell: (row) => row.firm_name,
        }
      ] : [],
    {
      name: "Points",
      cell: (row) => row.points,
      sortable: true,
      width: "120px",
    },
    {
      name: "Redemtion Type",
      cell: (row) => getRedemptionType(row.redemption_type),
      sortable: true,
    },
    {
      name: "Ref No",
      cell: (row) => row.ref_no,
      sortable: true,
    },
    // {
    //   name: "Point Earned",
    //   cell: (row) => row.point_balance,
    //   sortable: true,
    // },
    // {
    //   name: "Point Balance",
    //   cell: (row) => row.point_earned,
    //   sortable: true,
    // },
    {
      name: "Balance",
      cell: (row) => {
        return (
          <div>
            <button
              onClick={() => {
                // console.log("giftssss", row.gift);
                fetchUserPointsData(row.app_user_id);
              }}
              className="flex justify-center items-center rounded bg-blue-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-blue-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-blue-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-blue-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
            >
              View Balance
            </button>
          </div>
        );
      },
      sortable: true,
    },
    {
      name: "",
      cell: (row) => {
        if (row.address && Object.keys(row.address).length > 0) {
          return (
            <div>
              <button
                onClick={() => {
                  setCurrentRefNo(row.ref_no);
                  setshowAddressModal(row.address);
                  setAddressStatus(row.is_address_verified);
                }}
                className="flex justify-center items-center rounded bg-blue-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-blue-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-blue-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-blue-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
              >
                View Address
              </button>
            </div>
          );
        } else {
          return "";
        }
      },
      sortable: true,
    },
    {
      name: "",
      cell: (row) => {
        if (row.gift) {
          return (
            <div>
              <button
                onClick={() => {
                  setGiftDetailPopUpToggle(true);
                  setGiftDetails(row.gift.gift);
                }}
                className="flex justify-center items-center rounded bg-green-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
              >
                View Gifts
              </button>
            </div>
          );
        } else {
          return "";
        }
      },
      sortable: true,
    },
    {
      name: "Status",
      cell: (row) => {
        // ── Gift type (1): workflow-aware ──────────────────────────────────
        if (row.redemption_type == "1") {
          const ws = rowWorkflowStatus[row.id];

          // Workflow is active for this row
          if (ws && !ws.no_workflow) {
            // Shared History button — compact with clock icon
            const historyBtn = (
              <button
                onClick={() => openHistory(row)}
                style={{
                  display: "inline-flex", alignItems: "center", gap: "3px",
                  fontSize: "10px", fontWeight: 600, padding: "2px 7px",
                  borderRadius: "12px", border: "1px solid #6366f1",
                  color: "#6366f1", background: "#eef2ff",
                  cursor: "pointer", marginTop: "4px", letterSpacing: "0.02em",
                  transition: "background 0.15s",
                }}
                onMouseEnter={e => e.currentTarget.style.background = "#e0e7ff"}
                onMouseLeave={e => e.currentTarget.style.background = "#eef2ff"}
              >
                <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5">
                  <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
                </svg>
                History
              </button>
            );

            // Level progress pill
            const levelPill = (
              <span style={{
                fontSize: "9px", fontWeight: 700, padding: "1px 6px",
                borderRadius: "10px", background: "#f1f5f9", color: "#64748b",
                letterSpacing: "0.03em", marginBottom: "2px",
              }}>
                Level {ws.current_level}/{ws.total_levels}
              </span>
            );

            // Workflow fully approved → OLD flow status button + History
            if (ws.is_fully_approved) {
              return (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "3px" }}>
                  <button
                    onClick={() => {
                      setCurrentRefNo(row.ref_no);
                      setSelectStatus(Number(row.status));
                      setCurrentUserType(row.user_type);
                      setLastStatus(Number(row.status));
                      if (Number(row.status) === 0) {
                        toast.error("This request has already been rejected.", { id: "rejected-status" });
                        return;
                      }
                      setPopUpBtnToggle(true);
                    }}
                    className="flex justify-center items-center rounded bg-gray-900 px-1 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-gray-600"
                  >
                    {Number(row.status) <= 10
                      ? getRedeemedGiftsStatusData?.body?.[Number(row.status)]
                      : redemptionHierarchy?.[row.user_type]?.[Number(row.status) - 11]}
                  </button>
                  {historyBtn}
                </div>
              );
            }

            // Workflow rejected → OLD flow status button (shows rejected status) + History
            if (ws.is_rejected) {
              return (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "3px" }}>
                  <button
                    onClick={() => {
                      setCurrentRefNo(row.ref_no);
                      setSelectStatus(Number(row.status));
                      setCurrentUserType(row.user_type);
                      setLastStatus(Number(row.status));
                      toast.error("This request has already been rejected.", { id: "rejected-status" });
                    }}
                    className="flex justify-center items-center rounded bg-gray-900 px-1 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-gray-600"
                  >
                    {Number(row.status) <= 10
                      ? getRedeemedGiftsStatusData?.body?.[Number(row.status)]
                      : redemptionHierarchy?.[row.user_type]?.[Number(row.status) - 11]}
                  </button>
                  {historyBtn}
                </div>
              );
            }

            // Current user can approve/reject
            if (ws.can_approve) {
              return (
                <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "4px" }}>
                  {levelPill}
                  <div style={{ display: "flex", gap: "4px" }}>
                    <button
                      onClick={() => openWfModal(row, "approve")}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "3px",
                        fontSize: "11px", fontWeight: 600, padding: "4px 9px",
                        borderRadius: "6px", border: "none",
                        background: "linear-gradient(135deg,#16a34a,#15803d)",
                        color: "#fff", cursor: "pointer",
                        boxShadow: "0 1px 3px rgba(22,163,74,0.35)",
                        transition: "opacity 0.15s",
                      }}
                      onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                      onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                    >
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><polyline points="20 6 9 17 4 12"/></svg>
                      Accept
                    </button>
                    <button
                      onClick={() => openWfModal(row, "reject")}
                      style={{
                        display: "inline-flex", alignItems: "center", gap: "3px",
                        fontSize: "11px", fontWeight: 600, padding: "4px 9px",
                        borderRadius: "6px", border: "none",
                        background: "linear-gradient(135deg,#dc2626,#b91c1c)",
                        color: "#fff", cursor: "pointer",
                        boxShadow: "0 1px 3px rgba(220,38,38,0.35)",
                        transition: "opacity 0.15s",
                      }}
                      onMouseEnter={e => e.currentTarget.style.opacity = "0.85"}
                      onMouseLeave={e => e.currentTarget.style.opacity = "1"}
                    >
                      <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>
                      Reject
                    </button>
                  </div>
                  {historyBtn}
                </div>
              );
            }

            // Not this user's turn — pending + History
            return (
              <div style={{ display: "flex", flexDirection: "column", alignItems: "flex-start", gap: "3px" }}>
                <span style={{
                  display: "inline-flex", alignItems: "center", gap: "4px",
                  fontSize: "11px", fontWeight: 600, padding: "4px 10px",
                  borderRadius: "6px", background: "#fffbeb", color: "#b45309",
                  border: "1px solid #fde68a",
                }}>
                  <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/></svg>
                  Pending L{ws.current_level}/{ws.total_levels}
                </span>
                {historyBtn}
              </div>
            );
          }


          // No workflow configured → original behaviour
          return (
            <button
              onClick={() => {
                setCurrentRefNo(row.ref_no);
                setSelectStatus(Number(row.status));
                setCurrentUserType(row.user_type);
                setLastStatus(Number(row.status));
                if (Number(row.status) === 0) {
                  toast.error("This request has already been rejected.", { id: "rejected-status" });
                  return;
                }
                setPopUpBtnToggle(true);
              }}
              className="flex justify-center items-center rounded bg-gray-900 px-1 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white"
            >
              {Number(row.status) <= 10
                ? getRedeemedGiftsStatusData?.body?.[Number(row.status)]
                : redemptionHierarchy?.[row.user_type]?.[Number(row.status) - 11]}
            </button>
          );
        }

        // ── type 0: reject button ──────────────────────────────────────────
        if (row.redemption_type == "0") {
          return (
            <button
              onClick={(e) => handleReject(e, row)}
              className="flex justify-center items-center rounded bg-danger px-3 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white"
            >
              <TiTimes className="mr-1" /> Reject
            </button>
          );
        }

        // ── other types ────────────────────────────────────────────────────
        return (
          <button className="flex justify-center items-center rounded bg-gray-900 px-1 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white">
            {getRedeemedGiftsStatusData?.body?.[Number(row.status)]}
          </button>
        );
      },
      sortable: true,
      width: "180px",
    },
    {
      name: "",
      cell: (row) => (
        <>
          {" "}
          <button
            onClick={() => {
              // handleStatusChange(row, "2");
              setCurrentStatus(Number(row.status));
              setProgressBtnToggle(true);
              setRow(row.statusUpdateDetails);
            }}
            className="flex justify-center items-center rounded bg-green-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
          >
            View progress
          </button>
        </>
      ),
      sortable: true,
    },

    {
      name: "",
      cell: (row) => (
        <>
          {getRedeemedGiftsStatusData?.body && Number(row.status) <= 10 && Number(row.status) >= 7 &&
            <>
              <button
                onClick={() => {
                  setDeliveryDetailsSelectedData({
                    delivery_details: row.delivery_details,
                    ref_no: row.ref_no,
                    image: row.delivery_details.image
                  })
                  setPODFiles([...(row.delivery_details.image || [])])
                  setDeliveryDetailsModalToggle(true);
                }}
                className="flex justify-center items-center rounded bg-green-900 px-2 pb-1.5 pt-1.5 text-xs font-medium uppercase leading-normal text-white shadow-[0_4px_9px_-4px_#3b71ca] transition duration-150 ease-in-out hover:bg-green-600 hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:bg-green-600 focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] focus:outline-none focus:ring-0 active:bg-green-700 active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.3),0_4px_18px_0_rgba(59,113,202,0.2)] dark:shadow-[0_4px_9px_-4px_rgba(59,113,202,0.5)] dark:hover:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:focus:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)] dark:active:shadow-[0_8px_9px_-4px_rgba(59,113,202,0.2),0_4px_18px_0_rgba(59,113,202,0.1)]"
              >
                Update POD
              </button>
            </>}
        </>
      ),
      sortable: true,
    },

    {
      name: "Created At",
      cell: (row) => new Date(row.created_at).toLocaleString(),
      sortable: true,
    },
  ];

  // console.log("extra status", extraStatus);

  const handlePageChange = (pageNumber) => {
    const newOffset = (pageNumber - 1) * limit;
    setOffset(newOffset);
    setRequest((prevRequest) => ({ ...prevRequest, offset: newOffset }));
    setCurrentPage(pageNumber);
  };

  const handlePerRowsChange = (newPerPage, page) => {
    setRequest((prevRequest) => ({
      ...prevRequest,
      limit: newPerPage,
      offset: 0,
    }));
    setLimit(newPerPage);
    setOffset(0);
    setCurrentPage(1);
    setPaginationResetToggle((prev) => !prev);

  };


  const [
    isAddressVerfied,
    {
      data: isAddressVerfiedData,
      error: isAddressVerfiedError,
    },
  ] = useUpdateIsAddressVerifiedMutation();

  const handleAddressAction = (action) => {

    let newStatus = null;
    if (action == "approve") {
      newStatus = true;
    } else if (action == "reject") {
      newStatus = false;
    }
    isAddressVerfied({
      token: sessionStorage.getItem("access_token"),
      tenant_id: JSON.parse(sessionStorage.getItem("vendorData")).tenant_id,
      body: {
        is_approved: newStatus,
        ref_no: currentRefNo,
      },
    })

  };

  useEffect(() => {
    if (isAddressVerfiedData) {
      console.log("isAddressVerfiedData", isAddressVerfiedData);
      setshowAddressModal(false);
      handleFetchRedemptionHistory();
    }

    if (isAddressVerfiedError) {
      console.log("isAddressVerfiedError", isAddressVerfiedError);
    }
  }, [isAddressVerfiedData, isAddressVerfiedError]);

  const handleFileChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    setPODFiles((prev) => [...prev, ...selectedFiles]);
  };

  // Handle giftWorkflowAction response
  useEffect(() => {
    if (wfActionData) {
      toast.dismiss();
      const body = wfActionData.body || {};

      if (body.is_final_approval) {
        // Final level: auto-update the redemption status silently
        // is_rejection:true  → status 0 (Rejected)
        // is_rejection:false → status 2 (Approved)
        const finalStatus = body.is_rejection ? 0 : 2;
        const ref_no      = body.ref_no;

        toast.loading(
          body.is_rejection ? "Rejecting request…" : "Approving request…",
          { id: "wfFinalStatus" }
        );

        updateRedeemedGiftsStatus({
          token:     sessionStorage.getItem("access_token"),
          tenant_id: tenant_id_num,
          body: { status: finalStatus, ref_no, status_change_at: "2" },
        });
      } else {
        // Intermediate level — just show a success toast and refresh
        toast.success(wfActionData.message || "Action completed", { id: "wfActionSuccess" });
        handleFetchRedemptionHistory();
      }
    }
    if (wfActionError) {
      toast.dismiss();
      toast.error(wfActionError?.data?.message || "Action failed", { id: "wfActionError" });
    }
  }, [wfActionData, wfActionError]);


  return (
    <>
      <div className="flex w-full bg-gray-200 h-full justify-center">
        <div className="w-full ">
          <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
            Redeem Request
            <LinksComponent />
          </div>

          <div className="p-3">
            {/* {redemptionHistoryCsvData &&
              redemptionHistoryCsvData?.body?.data && (
                <ExportCSV
                  data={
                    redemptionHistoryCsvData &&
                    redemptionHistoryCsvData?.body?.data
                  }
                  columnsToExport={[
                    "name",
                    "email",
                    "mobile",
                    "user_type",
                    "points",
                    "redemption_type",
                    "ref_no",
                    "gift.gift[0].name"
                  ]}
                />
              )} */}

            <div className="mb-2">
              <CustomExport
                fetchData={handleFetchRedemptionHistoryCsv}
                data={csvData}
                defaultColumnExport={[
                  "name",
                  "email",
                  "mobile",
                  "user_type",
                  "user_id",
                  "points",
                  "redemption_type",
                  "ref_no",
                  "gift", 
                  "address", 
                  "delivery_details",
                  "statusUpdateDetails"
                  // "gift.gift[0].name",
                ]}
                filename="redeem_request"
                formatColumns={TenantSlugs.borosil == JSON.parse(sessionStorage.getItem("vendorData")).tenant_id ? [
                  "gift", "address", "delivery_details", "statusUpdateDetails"
                ] : []}
              />
            </div>
            <div className="border-b  border-gray-300 bg-gray-50 rounded-t-lg p-3">
              <div className="flex  space-x-2 ">
                <div className="w-52">
                  <div className="relative searchin">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Name
                    </label>
                    <input
                      type="search"
                      id="default-search"
                      className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                      placeholder="Name..."
                      required
                      value={request.name}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return { ...prevState, name: newValue };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="w-52">
                  <div className="relative searchin">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Mobile
                    </label>
                    <input
                      type="search"
                      id="default-search"
                      className="w-full p-2 text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                      placeholder="Mobile No..."
                      required
                      value={request.mobile}
                      onChange={(e) => {
                        const newValue = e.target.value;
                        setRequest((prevState) => {
                          return { ...prevState, mobile: newValue };
                        });
                      }}
                    />
                  </div>
                </div>

                <div className="w-52">
                  <div className="relative searchin topslt">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      Zones
                    </label>
                    <div className="relative searchin">
                      <SelectComponent
                        placeholder={"Select Zone*"}
                        selected={userZone}
                        setSelected={setUserZone}
                        dataArr={allZones}
                      />
                    </div>
                  </div>
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    From Date
                  </label>
                  <input
                    type="date"
                    className="w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    placeholder=""
                    value={request.startDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          startDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 searchin">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    End Date
                  </label>
                  <input
                    type="date"
                    className="w-full  text-sm text-gray-900 border border-gray-300 rounded-lg bg-white focus:ring-blue-500 focus:border-blue-500 inputp"
                    placeholder=""
                    value={request.endDate}
                    onChange={(e) => {
                      const newValue = e.target.value;
                      setRequest((prevState) => {
                        return {
                          ...prevState,
                          endDate: newValue,
                        };
                      });
                    }}
                  />
                </div>

                <div className="w-52 ">
                  <div className="flex-col slc_dvd topslt">
                    <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                      User Types
                    </label>
                    <div className="relative searchin">
                      {appUsers && appUsers.length > 0 && (
                        <SelectComponent
                          className="capitalize"
                          //title={"User Types"}
                          selected={userTypesArray}
                          setSelected={setUserTypesArray}
                          dataArr={appUsers}
                        />
                      )}
                    </div>
                  </div>
                </div>

                <div className="">
                  <label className="block text-sm font-medium capitalize leading-6 text-gray-900 mb-1">
                    &nbsp;
                  </label>
                  <div className="relative searchin gap-2 flex">
                    <button
                      className="py-2 btn btn-outline-primary clear-both float-right  pdbtn_all"
                      onClick={() => {
                        handleFetchRedemptionHistory();
                        // handleFetchRedemptionHistoryCsv();
                      }}
                    >
                      Search
                    </button>

                    <button
                      className="btn btn-outline-primary clear-both float-right pdbtn_all whitespace-nowrap"
                      onClick={() => {
                        clearFilters();
                      }}
                    >
                      Clear Filter
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-3 bg-white shadow rounded-lg">
              <DataTableComponent
                keyField={(row) => row.SNo}
                columns={columns}
                // title={""}
                data={myList}
                // loading={loading}
                totalRows={totalRows}
                handlePerRowsChange={handlePerRowsChange}
                handlePageChange={handlePageChange}
                paginationDefaultPage={currentPage}
                paginationResetDefaultPage={paginationResetToggle}
              ></DataTableComponent>
              {popUpBtnToggle && (
                <ModalComponent
                  size={"md"}
                  show={popUpBtnToggle}
                  setShow={setPopUpBtnToggle}
                >
                  <div className="w-full p-4">
                    <div className="w-full flex justify-center ">
                      <select
                        type="text"
                        className="shadow-sm bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 h-auto capitalize"
                        // placeholder="Add new UserType"
                        value={selectStatus}
                        onChange={(e) =>
                          setSelectStatus(Number(e.target.value))
                        }
                      >
                        <option key={0} value={Number(0)}>
                          {"Reject"}
                        </option>
                        <option key={1} value={Number(1)}>
                          {"Pending"}
                        </option>
                        {getExtraRedeemedGiftsStatusData &&
                          getExtraRedeemedGiftsStatusData.body.map(
                            (x, index) => {
                              return (
                                <option
                                  key={11 + index}
                                  value={Number(11 + index)}
                                >
                                  {x}_approval
                                </option>
                              );
                            }
                          )}
                        {getRedeemedGiftsStatusData &&
                          getRedeemedGiftsStatusData.body.map((x, index) => {
                            if (index == 0 || index == 1) {
                              return <></>;
                            } else {
                              return (
                                <option key={index} value={Number(index)}>
                                  {x}
                                </option>
                              );

                            }
                          })}
                      </select>
                    </div>
                    <div className="w-full flex justify-center mt-4 ">
                      <button
                        className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center "
                        onClick={handleUpdateRedeemedGiftsStatus}
                      >
                        Submit
                      </button>
                    </div>
                  </div>
                </ModalComponent>
              )}
              {progressBtnToggle && (
                <ModalComponent
                  size={"sm"}
                  show={progressBtnToggle}
                  setShow={setProgressBtnToggle}
                >
                  <div className="w-full p-4">
                    <div className="flex justify-start pl-4 ">
                      <ol class="relative text-gray-500 border-l border-gray-200 dark:border-gray-700 dark:text-gray-400">
                        {getRedeemedGiftsStatusData.body.map((x, index) => {
                          if (index == 0) {
                            return <></>;
                          }
                          if (index <= currentStatus) {
                            return (
                              <li class="mb-10 ml-7 flex items-center">
                                <span class="absolute flex items-center justify-center w-8 h-8 bg-green-200 rounded-full -left-4 ring-4 ring-white dark:ring-gray-900 dark:bg-green-900">
                                  <svg
                                    class="w-3.5 h-3.5 text-green-500 dark:text-green-400"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 16 12"
                                  >
                                    <path
                                      stroke="currentColor"
                                      strokeLinecap="round"
                                      strokeLinejoin="round"
                                      strokeWidth="2"
                                      d="M1 5.917 5.724 10.5 15 1.5"
                                    />
                                  </svg>
                                </span>
                                <h3 class="font-medium leading-tight capitalize fntchng">
                                  {x}

                                  {row &&
                                    row.length > 0 &&
                                    row
                                      .filter((y) => +y.status === index)
                                      .map((filteredRow) => (
                                        <span key={filteredRow.id}>
                                          {filteredRow?.created_name} <br />
                                          {new Date(
                                            filteredRow.created_at
                                          ).toLocaleString()}
                                        </span>
                                      ))}
                                </h3>
                              </li>
                            );
                          } else {
                            return (
                              <li class="mb-10 ml-7 flex items-center">
                                <span class="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -left-4 ring-4 ring-white dark:ring-gray-900 dark:bg-gray-700">
                                  <svg
                                    class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400"
                                    aria-hidden="true"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="currentColor"
                                    viewBox="0 0 20 16"
                                  >
                                    <path d="M18 0H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2ZM6.5 3a2.5 2.5 0 1 1 0 5 2.5 2.5 0 0 1 0-5ZM3.014 13.021l.157-.625A3.427 3.427 0 0 1 6.5 9.571a3.426 3.426 0 0 1 3.322 2.805l.159.622-6.967.023ZM16 12h-3a1 1 0 0 1 0-2h3a1 1 0 0 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Zm0-3h-3a1 1 0 1 1 0-2h3a1 1 0 1 1 0 2Z" />
                                  </svg>
                                </span>
                                <h3 class="font-medium leading-tight capitalize">
                                  {x}
                                </h3>
                                {/* <p class="text-sm">Step details here</p> */}
                              </li>
                            );
                          }
                        })}

                        {/* <li class="mb-10 ml-6">
                        <span class="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -left-4 ring-4 ring-white dark:ring-gray-900 dark:bg-gray-700">
                          <svg
                            class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 18 20"
                          >
                            <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2Zm-3 14H5a1 1 0 0 1 0-2h8a1 1 0 0 1 0 2Zm0-4H5a1 1 0 0 1 0-2h8a1 1 0 1 1 0 2Zm0-5H5a1 1 0 0 1 0-2h2V2h4v2h2a1 1 0 1 1 0 2Z" />
                          </svg>
                        </span>
                        <h3 class="font-medium leading-tight">Review</h3>
                        <p class="text-sm">Step details here</p>
                      </li>
                      <li class="ml-6">
                        <span class="absolute flex items-center justify-center w-8 h-8 bg-gray-100 rounded-full -left-4 ring-4 ring-white dark:ring-gray-900 dark:bg-gray-700">
                          <svg
                            class="w-3.5 h-3.5 text-gray-500 dark:text-gray-400"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 18 20"
                          >
                            <path d="M16 1h-3.278A1.992 1.992 0 0 0 11 0H7a1.993 1.993 0 0 0-1.722 1H2a2 2 0 0 0-2 2v15a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V3a2 2 0 0 0-2-2ZM7 2h4v3H7V2Zm5.7 8.289-3.975 3.857a1 1 0 0 1-1.393 0L5.3 12.182a1.002 1.002 0 1 1 1.4-1.436l1.328 1.289 3.28-3.181a1 1 0 1 1 1.392 1.435Z" />
                          </svg>
                        </span>
                        <h3 class="font-medium leading-tight">Confirmation</h3>
                        <p class="text-sm">Step details here</p>
                      </li> */}
                      </ol>
                    </div>
                  </div>
                </ModalComponent>
              )}

              {giftDetailPopUpToggle && (
                <ModalComponent
                  size={"md"}
                  show={giftDetailPopUpToggle}
                  setShow={setGiftDetailPopUpToggle}
                >
                  <div className="w-full ">
                    <div className="w-full p-4">
                      {giftDetails &&
                        giftDetails.map((x) => {
                          return (
                            <div className="flex gap-3 items-center bg-gray-50 border border-gray-100 rounded-sm overflow-hidden p-2 mb-2">
                              <div className="w-1/5 border bg-white border-gray-100 rounded-sm overflow-hidden p-2">
                                <img
                                  src={x.images[0]}
                                  alt={"error loading image"}
                                />
                              </div>
                              <div className="w-4/5">
                                <span className="capitalize block">
                                  <span className="text-gray-400">name</span>
                                  &nbsp;&nbsp;:&nbsp;&nbsp;{x.name}
                                </span>
                                <span className="capitalize block">
                                  <span className="text-gray-400">brand</span>
                                  &nbsp;&nbsp;:&nbsp;&nbsp;{x.brand}
                                </span>
                                <span className="capitalize block">
                                  <span className="text-gray-400">point</span>
                                  &nbsp;&nbsp;:&nbsp;&nbsp;{x.points}
                                </span>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  </div>
                </ModalComponent>
              )}

              {showAddressModal && Object.keys(showAddressModal).length > 0 && (
                <ModalComponent
                  size={"md"}
                  show={
                    showAddressModal && Object.keys(showAddressModal).length > 0
                      ? true
                      : false
                  }
                  setShow={setshowAddressModal}
                >
                  <div className="w-full">
                    <div className="w-full">
                      <div className="p-3 bg-white rounded-lg shadow-md  mx-auto">
                        <h2 className="text-lg text-center font-bold mb-4">
                          Address Details
                        </h2>
                        <div className="mb-2">
                          <span className="font-semibold">Address: </span>
                          {showAddressModal?.address ? showAddressModal.address : showAddressModal?.data?.address}
                        </div>
                        <div className="mb-2">
                          <span className="font-semibold">Pincode: </span>
                          {showAddressModal.pincode}
                        </div>
                        <div className="mb-2">
                          <span className="font-semibold">District: </span>
                          {showAddressModal.district}
                        </div>
                        <div className="mb-2">
                          <span className="font-semibold">City: </span>
                          {showAddressModal.city}
                        </div>
                        <div className="mb-2">
                          <span className="font-semibold">State: </span>
                          {showAddressModal.state}
                        </div>
                        <div className="mb-2">
                          <span className="font-semibold">Country: </span>
                          {showAddressModal.country}
                        </div>


                        {addressStatus == null && (
                          <div className="flex justify-center gap-6 mt-6">
                            <button
                              onClick={() => handleAddressAction("approve")}
                              className="flex items-center gap-2 px-5 py-2 rounded-xl bg-green-600 text-white font-medium shadow-md hover:bg-green-700 hover:shadow-lg transition-all"
                            >
                              ✅ Approve
                            </button>
                            <button
                              onClick={() => handleAddressAction("reject")}
                              className="flex items-center gap-2 px-5 py-2 rounded-xl bg-red-600 text-white font-medium shadow-md hover:bg-red-700 hover:shadow-lg transition-all"
                            >
                              ❌ Reject
                            </button>
                          </div>
                        )}

                        {addressStatus === true && (
                          <div className="flex justify-center mt-6">
                            <span className="px-5 py-2 rounded-md bg-green-100 text-green-700 font-semibold ">
                              ✅ Approved
                            </span>
                          </div>
                        )}

                        {addressStatus === false && (
                          <div className="flex justify-center mt-6">
                            <span className="px-5 py-2 rounded-md bg-red-100 text-red-700 font-semibold ">
                              ❌ Rejected
                            </span>
                          </div>
                        )}


                      </div>


                    </div>
                  </div>
                </ModalComponent>
              )}

              {balancePopupModal && (
                <ModalComponent
                  size={"md"}
                  show={balancePopupModal}
                  setShow={setBalancePopupModal}
                >
                  <div className="w-full ">
                    <div className="w-full p-4">
                      <div className="flex items-center bg-gray-50 border border-gray-100 rounded-sm overflow-hidden p-2 mb-2">

                        <div className="w-full">
                          <h2 className="text-lg text-center font-bold mb-2">
                            Point Details
                          </h2>
                          <div className="">
                            <span className="capitalize block">
                              <span className="text-black">Point Earned</span>
                              &nbsp;&nbsp;:&nbsp;&nbsp;
                              {formatter.format(balanceDetails.point_earned)}
                            </span>
                            <span className="capitalize block">
                              <span className="text-black">Point Balance</span>
                              &nbsp;&nbsp;:&nbsp;&nbsp;
                              {formatter.format(balanceDetails.point_balance)}
                            </span>
                            <span className="capitalize block">
                              <span className="text-black">Point Redeemed</span>
                              &nbsp;&nbsp;:&nbsp;&nbsp;
                              {formatter.format(balanceDetails.point_redeemed)}
                            </span>

                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ModalComponent>
              )}


              {deliveryDetailsModalToggle && (
                <ModalComponent
                  size={"md"}
                  show={deliveryDetailsModalToggle}
                  setShow={setDeliveryDetailsModalToggle}
                >
                  <div className="w-full p-4 space-y-4">

                    {deliveryDetailsSelectedData.delivery_details ? (
                      <div className="space-y-2">
                        <p className="text-base font-semibold text-gray-600">Current Delivery Details:</p>
                        <div className="text-sm text-gray-800">
                          <p><strong>Partner:</strong> {deliveryDetailsSelectedData.delivery_details?.delivery_partner || "N/A"}</p>
                          <p><strong>Tracking ID:</strong> {deliveryDetailsSelectedData.delivery_details?.tracking_id || "N/A"}</p>
                        </div>
                      </div>
                    ) : (
                      <p className="text-sm text-gray-500">No delivery details available.</p>
                    )}

                    <div className="space-y-3">
                      <label className="block text-sm font-medium text-gray-700">Update Delivery Partner</label>
                      <select
                        className="w-full border rounded-md px-3 py-2 text-sm"
                        value={updatedDeliveryPartner}
                        onChange={(e) => setUpdatedDeliveryPartner(e.target.value)}
                      >
                        <option value="">Select Delivery Partner</option>
                        {[
                          "Delhivery",
                          "Shiprocket",
                          "Mark express",
                          "Trackon",
                          "Skyking",
                          "Anjani couerier",
                          "safe express",
                          "Amazon shipping",
                          "Ecom Express",
                          "DTDC",
                          "EKART",
                          "SHADOW FAX SURFACE",
                          "Xpress bees",
                          "Clickpost",
                          "Bluedart",
                          "FedEx",
                          "Gati",
                          "Flyking Courier",
                          "Ashok Airways",
                          "Professional Courier",
                          "Trackon",
                          "Pushpak Courier",
                          "Speed Post"
                        ].map((partner) => (
                          <option key={partner} value={partner}>
                            {partner}
                          </option>
                        ))}
                      </select>

                      <label className="block text-sm font-medium text-gray-700">Tracking ID</label>
                      <input
                        type="text"
                        className="w-full border rounded-md px-3 py-2 text-sm"
                        value={updatedTrackingId}
                        onChange={(e) => setUpdatedTrackingId(e.target.value)}
                        placeholder="Enter Tracking ID"
                      />

                    <label className="block text-sm font-medium text-gray-700">Documents</label>

                    <div className="grid grid-cols-3 gap-4 mt-4">

                    {podFiles?.map((file, index) => {
                      const isImage = file?.type?.startsWith("image/") || /\.(jpg|jpeg|png|gif|webp|bmp)$/i.test(file.file);
                      const url = isImage ? file.fileLink || URL.createObjectURL(file) : null;

                      return (
                        <div key={index} className="relative border rounded p-2 flex flex-col items-center">
                          <button
                            type="button"
                            onClick={() => setPODFiles(podFiles?.filter((_, i) => i !== index))}
                            className="absolute top-1 right-1 text-gray-500 hover:text-red-500"
                          >
                            ×
                          </button>
                          {isImage ? (
                            <img
                              src={url}
                              alt={file.name}
                              className="h-24 w-24 object-cover"
                              onLoad={() => URL.revokeObjectURL(url)} // cleanup
                            />
                          ) : (
                            <div className="text-sm break-all flex items-center justify-center h-full">{file.file || file.name}</div>
                          )}
                        </div>
                      );
                    })}
                    </div>

                    <label className="flex flex-col items-center justify-center w-full h-20 border-2 border-gray-300 border-dashed rounded-lg cursor-pointer bg-gray-50  hover:bg-gray-100  ">
                    <div className="flex flex-col items-center justify-center pt-4 pb-3">
                      <svg
                        aria-hidden="true"
                        className="w-12 h-12 mb-1 text-gray-400"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          stroke-linecap="round"
                          strokeLinejoin="round"
                          stroke-width="2"
                          d="M7 16a4 4 0 01-.88-7.903A5 5 0 1115.9 6L16 6a5 5 0 011 9.9M15 13l-3-3m0 0l-3 3m3-3v12"
                        ></path>
                      </svg>
                      <p className="text-sm text-gray-500">
                          <p className="mb-2 text-sm text-gray-500">
                              Click to <b>upload documents</b>
                          </p>
                      </p>
                    </div>
                    <input
                      type="file"
                        multiple={false}
                      className="hidden"
                      onChange={(e) => {
                        handleFileChange(e);
                        e.target.value = null
                      }}
                    />
                  </label>

                      <button onClick={handleUpdateDeliveryDetails} className="w-full mt-2 bg-blue-700 hover:bg-blue-600 text-white py-2 px-4 rounded-md">
                        Update Delivery Details
                      </button>
                    </div>
                  </div>
                </ModalComponent>
              )}

            </div>
          </div>
        </div>
      </div>
      {/* ── Workflow Action Modal ─────────────────────────────────────────── */}
      <ModalComponent
        size="md"
        show={wfModal}
        setShow={setWfModal}
      >
        <div className="p-4">
          <h3 className="text-base font-semibold text-gray-800 mb-3">
            {wfAction === "approve" ? "✅ Approve Request" : "❌ Reject Request"}
          </h3>
          {wfRow && (
            <>
              <p className="text-sm font-medium mb-1 text-gray-700">
                Ref No: <span className="text-gray-900">{wfRow.ref_no}</span>
              </p>
              <p className="text-sm text-gray-600 mb-3">
                User: {wfRow.name} &nbsp;|&nbsp; Points: {wfRow.points}
              </p>
            </>
          )}
          <label className="block text-xs font-medium text-gray-700 mb-1">Remark *</label>
          <textarea
            rows={3}
            placeholder="Enter remark"
            value={wfRemark}
            onChange={(e) => setWfRemark(e.target.value)}
            className="w-full border border-gray-300 rounded-md px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-indigo-400"
          />
          <div className="flex gap-3 mt-4">
            <button
              disabled={wfLoading}
              onClick={handleWfConfirm}
              className={`flex-1 py-2 rounded-md text-white text-sm font-semibold ${
                wfAction === "approve" ? "bg-green-600 hover:bg-green-700" : "bg-red-600 hover:bg-red-700"
              }`}
            >
              {wfLoading ? "Please wait..." : wfAction === "approve" ? "Confirm Approve" : "Confirm Reject"}
            </button>
            <button
              onClick={() => setWfModal(false)}
              className="flex-1 py-2 rounded-md bg-gray-200 text-gray-700 text-sm font-semibold hover:bg-gray-300"
            >
              Cancel
            </button>
          </div>
        </div>
      </ModalComponent>

      {/* ── Approval History Modal ────────────────────────────────────────── */}
      <ModalComponent
        size="md"
        show={historyModal}
        setShow={(val) => { setHistoryModal(val); if (!val) setHistoryLogs([]); }}
      >
        <div className="p-4 max-h-[70vh] overflow-y-auto">
          {historyRow && (
            <h3 className="text-base font-semibold text-gray-800 mb-3">
              Approval History — {historyRow.ref_no}
            </h3>
          )}
          {historyLoading && (
            <p className="text-center text-gray-500 text-sm py-4">Loading history…</p>
          )}
          {!historyLoading && historyLogs.length === 0 && (
            <p className="text-center text-gray-400 text-sm py-4">No approval logs found.</p>
          )}
          {historyLogs.length > 0 && (
            <ol className="relative border-l-2 border-indigo-200 ml-3">
              {historyLogs.map((log, idx) => (
                <li key={log.id || idx} className="mb-6 ml-6">
                  <span
                    className={`absolute -left-3 flex h-6 w-6 items-center justify-center rounded-full ring-4 ring-white ${
                      log.status === "1" ? "bg-green-500" : "bg-red-500"
                    }`}
                  >
                    <span className="text-white text-[10px] font-bold">{log.level}</span>
                  </span>
                  <div className="rounded-lg border border-gray-100 bg-white p-3 shadow-sm">
                    <div className="flex items-center justify-between mb-1">
                      <span
                        className={`text-xs font-semibold px-2 py-0.5 rounded-full ${
                          log.status === "1"
                            ? "bg-green-100 text-green-700"
                            : "bg-red-100 text-red-700"
                        }`}
                      >
                        {log.status === "1" ? "Approved" : "Rejected"}
                      </span>
                      <span className="text-[11px] text-gray-400">
                        L{log.level}/{log.total_levels}
                      </span>
                    </div>
                    <p className="text-sm font-medium text-gray-800">
                      {log.user_name}
                      {log.user_role_name ? (
                        <span className="ml-1 text-xs text-gray-500">({log.user_role_name})</span>
                      ) : null}
                    </p>
                    {log.remarks && (
                      <p className="text-xs text-gray-600 mt-1 italic">&ldquo;{log.remarks}&rdquo;</p>
                    )}
                    <p className="text-[11px] text-gray-400 mt-1">
                      {new Date(log.created_at).toLocaleString()}
                    </p>
                  </div>
                </li>
              ))}
            </ol>
          )}
        </div>
      </ModalComponent>
    </>
  );
};

export default RedeemRequest;


const csvColumns = [
  { header: "Id", field: "id" },
  { header: "Reference Number", field: "ref_no" },
  { header: "App User ID", field: "app_user_id" },
  { header: "User Type", field: "user_type" },
  { header: "Redeemed Points", field: "points" },
  { header: "User Name", field: "name" },
  { header: "Email", field: "email" },
  { header: "Mobile", field: "mobile" },
  { header: "Remarks", field: "remarks" },
  { header: "Gift Name", field: "gift.gift[0].name" },
  { header: "Gift Brand", field: "gift.gift[0].brand" },
  { header: "Gift Value", field: "gift.gift[0].value" },
  { header: "Address", field: "address.address" },
  { header: "City", field: "address.city" },
  { header: "Pincode", field: "address.pincode" },
  { header: "District", field: "address.district" },
  { header: "State", field: "address.state" },
  { header: "Current Status", field: "statusUpdateDetails[length-1].status_name" },
  { header: "Created At", field: "created_at" },
  { header: "Total Earned", field: "point_earned" },
  { header: "Curr Balance", field: "point_balance" },
  { header: "Total Redeemed", field: "point_redeemed" }

];
